<template>
  <div>
    <div v-if="errorHandling" class="col-12 red">
      {{ errorHandling }}
    </div>
    <div class="col-12 white-bg p2">
      <div
        v-if="products.length === 0"
        class="col-12 card-top border"
      >
        <div class="flex flex-wrap">
          <div class="col-2 xs-hide flex justify-start items-center">
            <div class="user-icon red-bg">
              <i
                class="
                  icon
                  flex
                  justify-center
                  white
                  mx-auto
                  line-height-1
                  relative
                  h1
                  i-user
                  mt2
                "
              ></i>
            </div>
          </div>
          <div class="col-10 sm-col-8 flex justify-center">
            <h4 class="h4 mt1 mb0 center flex items-center">
              Il n'y a plus de produits à ajouter
            </h4>
          </div>
        </div>
      </div>

      <div
        v-for="(p, index) in products"
        :key="p.uuid"
        :class="[{'mb2': index < products.length-1}]"
      >
        <ProductItem :product="p" @product-selected="productSelected" />
      </div>
    </div>
  </div>
</template>

<script>
import ProductItem from '../../components/products/ProductItem';

export default {
  components: { ProductItem },
  computed: {
    products () {
      return this.$store.state.products;
    },
    errorHandling () {
      return this.$store.state.productError;
    }
  },
  methods: {
    productSelected (value) {
      this.$emit('product-selected', value);
    }
  }
};
</script>
